/** API вкладень документів (0419, 2026-08-12). */
import { api } from './client';

export interface Attachment {
  id: string;
  organization_id: string;
  document_type: string;
  document_id: string;
  filename: string;
  mime_type: string;
  size_bytes: number;
  original_size_bytes: number;
  created_at: string;
}

export const attachments = {
  list: (params: { organization_id: string; document_type: string; document_id: string }) =>
    api.get<Attachment[]>('/attachments', { params }).then((r) => r.data),
  upload: (p: { organization_id: string; document_type: string; document_id: string; file: File }) => {
    const fd = new FormData();
    fd.append('organization_id', p.organization_id);
    fd.append('document_type', p.document_type);
    fd.append('document_id', p.document_id);
    fd.append('file', p.file);
    // X-Silent-422: помилку показує панель своїм alert'ом (без глобального тоста).
    return api.post<Attachment>('/attachments', fd, {
      headers: { 'X-Silent-422': '1' },
    }).then((r) => r.data);
  },
  remove: (id: string) => api.delete(`/attachments/${id}`).then(() => undefined),
  /** Batch-прапорці «чи є вкладення» для колонок списків. */
  flags: (documentType: string, ids: string[]) =>
    api.get<Record<string, boolean>>('/attachments/flags', {
      params: { document_type: documentType, ids: ids.join(',') },
    }).then((r) => r.data),
  pdfInfo: (id: string) =>
    api.get<{ pages: number }>(`/attachments/${id}/pdf-info`).then((r) => r.data),
  pageImage: async (id: string, page: number): Promise<Blob> => {
    const r = await api.get(`/attachments/${id}/page-image`, {
      params: { page }, responseType: 'blob' });
    return r.data as Blob;
  },
  stampPdf: (id: string, overlays: {
    stamp_attachment_id: string; page: number;
    x_frac: number; y_frac: number; w_frac: number;
  }[]) =>
    api.post<Attachment>(`/attachments/${id}/stamp-pdf`, { overlays }).then((r) => r.data),
  /** Скачування через axios (JWT у заголовку) → Blob (для предпросмотру). */
  downloadBlob: async (id: string): Promise<Blob> => {
    const r = await api.get(`/attachments/${id}/download`, { responseType: 'blob' });
    return r.data as Blob;
  },
  /** Зайнятість сховища по доступних орг + модулях (профіль, 2026-08-31). */
  storageUsage: () =>
    api.get<StorageUsageOrg[]>('/attachments/storage-usage').then((r) => r.data),
  /** Очистка вкладень одного модуля в організації (незворотньо). */
  cleanupModule: (organizationId: string, module: string) =>
    api.delete('/attachments/storage', {
      params: { organization_id: organizationId, module },
    }).then(() => undefined),
};

export interface StorageUsageModule {
  module: string;
  files: number;
  bytes: number;
}

export interface StorageUsageOrg {
  organization_id: string;
  used_bytes: number;
  /** null — без обмеження за обсягом (картка ЕДО без оплачених блоків: межа — 20 документів, ч.1408). */
  quota_bytes: number | null;
  modules: StorageUsageModule[];
}
